export const LEVEL_OPTIONS = [
    { key: "all", value:"all", text: "All Levels"},
    { key: "junior", value:"entry_level", text: "Junior"},
    { key: "intermediate", value:"mid_level", text: "Intermediate"},
    { key: "senior", value:"senior_level", text: "Senior"}
];
